'use strict';

import $ from 'jquery';
import { viewport } from './utilities/viewport';
import { debounce } from './utilities/debounce';

let searchFilterParent = $('.facets-widget-checkbox');
let searchFilter = $('.facets-widget-checkbox__selector');
let searchFilterHeader = $('.facets-widget-checkbox__selector');
let clearAllButton = $('.clear-all-button');
let filterSummary = $('.block-facets-summary');
let checkBoxItem = $('.facets-widget-checkbox .facet-item input');
let checkBoxCheckMark = $('.facets-widget-checkbox .facet-item .checkmark');


function closeAllFilterDropdown() {
  searchFilter.parent().removeClass('expanded');
  searchFilter.parent().find('> .js-facets-checkbox-links').stop().slideUp(300);
  searchFilter.parent().find('.facets-widget-checkbox__selector').attr('aria-expanded', 'false');
}


$(document).ready(function () {
  // remove duplicate states from map list view & listing page map item
  if (!$('.path-search-priority-list-map, .path-search').length) {
    return;
  }

  let mapListStateTags = $('.ipl-map .list-view, .path-search').find('.search__content .field--name-field-state-map');
  mapListStateTags.each(function () {
    // hide map state tags if it's national
    if (!$(this).find('.field__item').length) {
      $(this).hide();
      return;
    }

    let states = [];
    $(this).find('.field__item').each(function () {
      if (states.includes($(this).text().trim())) {
        $(this).remove();
      } else {
        states.push($(this).text().trim());
      }
    });
  });
});

/* menu dropdown - desktop */
searchFilter.attr('aria-expanded', 'false');

searchFilterParent.hover(function () {
  if (viewport().width > 760) {
    $(this).toggleClass('expanded');
    $(this).find('> .js-facets-checkbox-links').stop().slideToggle(300);
    $(this).find('.facets-widget-checkbox__selector').attr('aria-expanded', 'true');
  }
});

searchFilter.on('click keydown', function (e) {
  // click on mobile or on enter key
  if (viewport().width <= 760 || (e.keyCode ? e.keyCode : e.which) == 13) {
    $(this).parent().toggleClass('expanded');
    $(this).next().stop().slideToggle(300);
    if ($(this).parent().hasClass('expanded')) {
      $(this).attr('aria-expanded', 'true');
    } else {
      $(this).attr('aria-expanded', 'false');
    }
  }
});

$('body').on('keydown', '.facets-checkbox', function (e) {
  var key = (e.keyCode ? e.keyCode : e.which);
  if (viewport().width > 760) {
    if (key == 9) { //tab
      if ($(e.target).is('ul li:last-child input')) {
        $(e.target).parents('.facets-widget-checkbox').toggleClass('expanded');
        $(e.target).parents('.facets-widget-checkbox').find('> .js-facets-checkbox-links').stop().slideToggle(300);
        $(e.target).parents('.facets-widget-checkbox').find('.facets-widget-checkbox__selector').attr('aria-expanded', 'false');
      }
    }
  }
});

checkBoxCheckMark.on('click', function () {
  $(this).siblings('label').click();
});

$(document).ready(function () {
  if (filterSummary.find('p').length <= 0) {
    clearAllButton.find('input').attr('disabled', 'disabled');
  }
});

clearAllButton.on('click', function () {
  let url = window.location.href.indexOf('keys=') > -1 ? window.location.href.split('&')[0] : window.location.href.split('?')[0];
  window.location.href = url;
});

$(document).on('click touchstart', function (e) {
  if (!$(e.target).closest('.block-facets').length) {
    closeAllFilterDropdown();
  }
});

$(window).on('resize', debounce(function () {
  if (viewport().width > 768) {
    closeAllFilterDropdown();
  }
}, 250));

$('.path-recommendations main form').prepend('<div class="filter-title"><span>Filter by:</span></div>');

let dropdown = $('.path-recommendations fieldset.js-form-wrapper');
let dropdownButton = $('.path-recommendations fieldset.js-form-wrapper legend');
dropdownButton.on('click', function () {
  if (parseInt($(window).width()) <= 760) {
    $(this).closest('.js-form-wrapper').toggleClass('expanded');
  }
});

  // dropdown.on('mouseover', function () {
  //   if (parseInt($(window).width()) > 760) {
  //     $(this).addClass('expanded');
  //     $(this).find('.fieldset-wrapper').stop(true).slideDown(300);
  //   }
  // });

  // dropdown.on('mouseout', function () {
  //   if (parseInt($(window).width()) > 760) {
  //     $(this).removeClass('expanded');
  //     $(this).find('.fieldset-wrapper').stop(true).slideUp(300);
  //   }
  // });


let searchFilterParentRecommendation = $('.search-filter-set .js-form-wrapper');
let searchFilterRecommendation = $('.search-filter-set legend');
let clearAllButtonRecommendation = $('#edit-reset--2');
let checkBoxItemRecommendation = $('.search-filter-set .fieldset-wrapper .form-checkboxes .js-form-type-checkbox input');
let checkBoxCheckMarkRecommendation = $('.search-filter-set .fieldset-wrapper .form-checkboxes .js-form-type-checkbox .au-control-input__text');


function closeAllFilterDropdownRecommendation() {
  searchFilterRecommendation.parent().removeClass('expanded');
  searchFilterRecommendation.parent().find('.fieldset-wrapper').removeClass('expanded');
  //searchFilterRecommendation.parent().find('> .fieldset-wrapper').stop().slideUp(300);
  searchFilterRecommendation.parent().find('legend').attr('aria-expanded', 'false');
}



/* menu dropdown - desktop */
searchFilterRecommendation.attr('aria-expanded', 'false');

searchFilterParentRecommendation.hover(function () {
  if (viewport().width > 760) {
    $(this).toggleClass('expanded');
    $(this).find('.fieldset-wrapper').toggleClass('expanded');
    //$(this).find('> .fieldset-wrapper').stop().slideToggle(300);
    $(this).find('legend').attr('aria-expanded', 'true');
  }
});

searchFilterRecommendation.attr("tabindex", 0);

searchFilterRecommendation.on('click keydown', function (e) {
  // click on mobile or on enter key
  if (viewport().width <= 760 || (e.keyCode ? e.keyCode : e.which) == 13) {
    $(this).parent().toggleClass('expanded');
    $(this).parent().find('.fieldset-wrapper').toggleClass('expanded');
    //$(this).next().stop().slideToggle(300);
    if ($(this).parent().hasClass('expanded')) {
      $(this).attr('aria-expanded', 'true');
    } else {
      $(this).attr('aria-expanded', 'false');
    }
  }
});

$(document).on('click touchstart', function (e) {
  if (!$(e.target).closest('.search-filter-set .js-form-wrapper').length) {
    closeAllFilterDropdownRecommendation();
  }
});

$(window).on('resize', debounce(function () {
  if (viewport().width > 768) {
    closeAllFilterDropdownRecommendation();
  }
}, 250));

